export enum CountyBlockerErrorType {
  BlockedCountyError = "BlockedCountyError",
}
